/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { Card, CardContent, Typography, Grid, Chip, useMediaQuery, CircularProgress } from "@mui/material";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import { Formater, LocalStorage, TypeRecords } from "src/framework/commons";
import { FullWidthButton } from "src/framework/components/buttons";
import "./styles.scss";
import { TCarrinho, TCarrinhoAvulso } from "../Carrinho/types";
import { resolveUploadUrl } from "src/store/global.store";
import { ComponenteType } from "src/types";
import theme from "src/theme/light";
import { CABO_ID, VALOR_MULTIPLO_CABO } from "src/pages/Home/constants";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { permissoes$ } from "src/framework/store";
import { CarrinhoStore } from "../Carrinho/store";

interface IAvulso {
    data: ComponenteType,
    classes: any
    onDetalhesClick?: (produto: ComponenteType) => void;
    onAdd?: (item: TCarrinhoAvulso) => void;
    adicaoDesabilitada: boolean;
    nomeMinHeight?: number;
    tagsMinHeight?: number;
    onNomeMinHeightChange?: () => void;
    onTagsMinHeightChange?: () => void;
}

const Avulso: FC<IAvulso> = ({ data, classes, onDetalhesClick, onAdd, adicaoDesabilitada, nomeMinHeight, tagsMinHeight, onNomeMinHeightChange, onTagsMinHeightChange}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const uploadUrl = resolveUploadUrl(LocalStorage.get("solar.uploads", true) || null) || ""

    const elementNome = useRef<any>();
    const elementTags = useRef<any>();

    const [atualOffsetTags, setatualOffsetTags] = useState<number>(1);
    const [atualOffsetNome, setAtualOffsetNome] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);

    const isAdmin = useMemo(() => {
        return PermissionUtil.isAdministrador(permissoes$.value);
    }, []);

    useEffect(() => {
        function updateSize() {
            setatualOffsetTags(elementTags?.current?.offsetHeight);
            setAtualOffsetNome(elementNome?.current?.offsetHeight);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    useEffect(() => {
        data.heightNome = elementNome?.current?.offsetHeight;
        if (onNomeMinHeightChange) {
            onNomeMinHeightChange();
        }
    }, [atualOffsetNome])

    useEffect(() => {
        data.heightTags = elementTags?.current?.offsetHeight;
        if (onTagsMinHeightChange) {
            onTagsMinHeightChange();
        }
    }, [atualOffsetTags])

    const renderNomeComponente = () => {
        if (!data) return ''

        if (PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_VISUALIZAR_CODIGO_COMPONENTE, permissoes$.value)) {
            return <strong>{data.id} - {data.nome || ""}</strong>
        }

        return <strong>{data.nome}</strong>
    }

    if (!data?.valor || !Number(data?.valor)) return <></>;
    
    return <Card className={`CardAvulso ${classes.CardProduto}`}>
        {uploadUrl && <img
            className={classes.itemImage}
            src={`//${uploadUrl}${data?.imagem || ""}`}
        />}
        <CardContent>
            <div style={{minHeight: tagsMinHeight || 0}}>
                <div ref={elementTags}>
                    {data?.grupo_categoria && <Chip
                        className="tags"
                        color="secondary"
                        label={data?.grupo_categoria?.toLocaleUpperCase()}
                    /> }                   
                    {data?.fabricante && <Chip
                        className="tags"
                        color="secondary"
                        label={data?.fabricante?.toLocaleUpperCase()}
                    /> }
                </div>
            </div>
            <div className="nome" style={{minHeight: nomeMinHeight}} >
                <p ref={elementNome}>
                    {renderNomeComponente()}
                </p>
            </div>

            <Typography variant="h5" color="primary" component="p">
                <strong>{Formater.toString(data?.valor || 0, TypeRecords.CURRENCY)}</strong>
            </Typography>
        </CardContent>
        <Grid size={12} spacing={1}
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
        >
            <Grid size={12} style={ isMobile ? { width: "100%" } : {}}>
                <FullWidthButton
                    variant="contained"
                    color="primary"
                    text="Adicionar ao carrinho"
                    disabled={adicaoDesabilitada || loading}
                    fullWidth={isMobile}
                    startIcon={loading ? <CircularProgress size="15px" /> : undefined}
                    onClick={async () => { 
                        setLoading(true);
                        if (data) {
                            const quantidadeAdd = data?.categoria_componentes_id === CABO_ID ? VALOR_MULTIPLO_CABO : 1;
                            const item: TCarrinhoAvulso = { 
                                componente_id: Number(data?.id),
                                quantidade: quantidadeAdd,
                                valor: data?.valor || 0,
                                componente: data
                            };

                            const carrinho: TCarrinho | null = CarrinhoStore.getCarrinho();
                            const find: TCarrinhoAvulso | undefined = carrinho?.avulsos?.find(i => (i?.componente?.id || i?.componente_id) === Number(data.id));

                            const quantidadeAtual = find?.quantidade || 0;
                            item.quantidade = quantidadeAtual + quantidadeAdd;
                            if (CarrinhoStore.validaQuantidadeMaximaAvulso(item, isAdmin)) {
                                item.quantidade = quantidadeAdd;
                                if (onAdd) { 
                                    await onAdd(item);
                                }
                            } else {
                                item.quantidade = quantidadeAtual;
                            }
                        }
                        setTimeout(() => { setLoading(false) }, 700);
                    }}
                />
            </Grid>
            <Grid size={12} style={ isMobile ? { width: "100%" } : {}}>
                <FullWidthButton
                    variant="outlined"
                    color="secondary"
                    text="Detalhes"
                    fullWidth={isMobile}
                    onClick={() => { onDetalhesClick && onDetalhesClick(data) }}
                />
            </Grid>
        </Grid>
    </Card>
}

export { Avulso }